var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useState } from 'react';
import { fontSizes } from '../../../defaultTheme';
import { handleBackspace, handleOnChange } from './helpers';
import Input from './subcomponents';
const Pinfield = (_a) => {
    var { type = 'tel', id, label = 'passcode', onChange, numberOfFields = 5, width = '37px', height = '44px', fontSize = fontSizes.root, autoFocus = true, className, hasError, isDisabled } = _a, props = __rest(_a, ["type", "id", "label", "onChange", "numberOfFields", "width", "height", "fontSize", "autoFocus", "className", "hasError", "isDisabled"]);
    const [values, setValues] = useState(Array(numberOfFields).fill(''));
    const inputRefs = [];
    for (let i = 0; i < numberOfFields; i += 1) {
        inputRefs.push(React.createRef());
    }
    const triggerChange = (newValues) => {
        setValues(newValues);
        onChange(newValues.join(''));
    };
    const handleOnFocus = (event) => {
        event.target.select();
    };
    return (_jsx("div", Object.assign({ id: id }, { children: values.map((value, index) => (_createElement(Input, Object.assign({}, props, { type: type, key: `${index + 1}`, className: className, "aria-label": `${label}-${index + 1}`, autoFocus: autoFocus && index === 0, width: width, height: height, fontSize: fontSize, "data-id": index, value: value, hasError: hasError, ref: inputRefs[index], onChange: (event) => handleOnChange(event, values, inputRefs, numberOfFields, type, triggerChange), onKeyDown: (event) => {
                handleBackspace(event, values, triggerChange, inputRefs);
                if (props.onKeyDown)
                    props.onKeyDown(event);
            }, onFocus: handleOnFocus, disabled: isDisabled })))) })));
};
export default Pinfield;
//# sourceMappingURL=Pinfield.js.map